import http from '@/services/http';



export const locationHelper = {
  async getGeocode(address) {
    try {
      const geolocationResponse = await http.get('/google-api/geocode', {
        params: {
          address: `${address.line1}, ${address.city}, ${address.state} ${address.postalCode}`
        }
      });

      if (!geolocationResponse) {
        throw new Error('No google geolocation result for address');
      }

      const geolocation = geolocationResponse.data.results[0];

      return geolocation;
    }
    catch (error) {
      throw error;
    }
  },
  // /*
  //   NOTE: CAPI does not currently support a robust search endpoint to find the
  //   closest delivery or shipping store. In the mean time, we have to search all
  //   stores in the USA and filter through those stores to find one with the attributes
  //   we need. It's a bit ugly and non performant, but we have no other choice.

  //   5,000 miles is bigger than the USA, so we should be good?
  // */
  async searchForLocations(geolocation, attributes, distance) {
    try {
      const storeSearchResponse = await http.get('/cardfree-api/v1/location/search', {
        params: {
          distance,
          latitude: geolocation.geometry.location.lat,
          longitude: geolocation.geometry.location.lng
        }
      });

      const locations = storeSearchResponse.data.data.filter(location => attributes.every((attribute) => {
        const matchingAttribute = location.attributes.find(attr => attr.code === attribute);

        return matchingAttribute && matchingAttribute.value;
      }));

      if (locations.length === 0) {
        throw new Error('Unable to find location with requested attributes.');
      }

      return locations[0];
    }
    catch (error) {
      throw error;
    }
  }
};


async function findClosestLocations({ address, attributes = [], distance = 5000 }) {
  try {
    const geolocationResponse = await locationHelper.getGeocode(address);

    const storeSearchResponse = await locationHelper.searchForLocations(geolocationResponse, attributes, distance);

    const addressLatAndLong = { latitude: geolocationResponse.geometry.location.lat, longitude: geolocationResponse.geometry.location.lng };

    return {
      location: storeSearchResponse,
      addressGeocodeData: addressLatAndLong
    };
  }

  catch (error) {
    throw error;
  }
}

export default findClosestLocations;
